
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import Vue from "vue";
import AppPageSettingsBackgroundImage from "../document-settings/PageSettingsBackgroundImage.vue";
import AppPageSettingsDefault from "../document-settings/PageSettingsDefault.vue";
import AppPageSettingsFont from "../document-settings/PageSettingsFont.vue";
import AppDefaultLanguage from "@/components/layout-editor/DefaultLanguage.vue";
import AppPropSelectAutocomplete from "@/components/prop-select/PropSelectAutocomplete.vue";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getSaleMapPropSelectGroup } from "@/utils/prop-select/sale-map-prop-group";
import { getContactAddressMapPropSelectGroup } from "@/utils/prop-select/contact-address-map-to-prop-select-group";
import { SaleLayoutConf } from "@/models/sale-layout";
import AppMarginEdit from "@/components/layout-editor/MarginEdit.vue";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import { ISelectItem } from "winfakt-vue-components";
import { PageNumberLocation } from "@/utils/sale-layouts/page-number-settings";
import { AuthService, SaleService } from "@/services";
import AppCustomCss from "@/components/layout-editor/CustomCss.vue";

export default Vue.extend({
	data() {
		return {
			selectedFileNameProp: "ID",
			defaultPrinterId: "",
			editPageNumberStyleOpen: false
		};
	},
	props: {
		layout: {
			type: Object as () => SaleLayout,
			required: true
		}
	},
	computed: {
		fileNameProperties(): PropSelectGroup {
			let result = getSaleMapPropSelectGroup();
			let invoiceAddress = getContactAddressMapPropSelectGroup();
			let deliveryAddress = getContactAddressMapPropSelectGroup();

			for (let item of invoiceAddress.items) {
				item.value = `InvoiceAddress.${item.value}`;
			}

			for (let item of deliveryAddress.items) {
				item.value = `DeliveryAddress.${item.value}`;
			}

			invoiceAddress.name = this.$ct("models.map.Sale.invoice-address");
			deliveryAddress.name = this.$ct("models.map.Sale.delivery-address");
			result.groups.push(invoiceAddress, deliveryAddress);

			return result;
		},
		pageNumberLocations():ISelectItem<PageNumberLocation>[]{
			return [
				{
					text: this.$ct(`page-number-location.HIDDEN`),
					value: PageNumberLocation.HIDDEN
				},
				{
					text: this.$ct(`page-number-location.BOTTOM`),
					value: PageNumberLocation.BOTTOM
				},
				{
					text: this.$ct(`page-number-location.TOP`),
					value: PageNumberLocation.TOP,
					disabled: this.layout.PageSettings.ShowHeaderOnlyOnFirstPage
				},
			];
		},
		pdfEngineItems():ISelectItem<boolean>[]{
			return [
				{
					text: "wkhtmltopdf",
					value: false
				},
				{
					text: "chromium",
					value: true
				}
			];
		},
		isSupport():boolean{
			return AuthService.isDevModeEnabled;
		}
	},
	methods: {
		addFileNameProp() {
			let input = (this.$refs.input as Vue).$refs.inputElement as HTMLInputElement;
			let index = input.selectionStart || 0;
			let fileName = this.layout.FileName;
			if (index > fileName.length) {
				index = fileName.length;
			}
			fileName = [fileName.slice(0, index), `{${this.selectedFileNameProp}}`, fileName.slice(index)].join("");
			this.layout.FileName = fileName;
		},
		async reset() {
			let confirm = await this.$wf.confirm(this.$ct("reset-to-defaults-confirm"), this.$t("common.yes"), this.$t("common.no"), this.$ct("common.warning"), "warning");
			if (confirm) {
				let saleLayout = new SaleLayoutConf();
				saleLayout.Data = await SaleService.getDefaultSaleLayout();
				this.layout.PageSettings = saleLayout.Data.PageSettings;
				this.layout.FileName = saleLayout.Data.FileName;
			}
		},
		setShowHeaderOnlyOnFirstPage(val:boolean){
			this.layout.PageSettings.ShowHeaderOnlyOnFirstPage = val;
			if (!val) return;
			if (this.layout.PageNumberSettings.Location != PageNumberLocation.TOP) return;
			this.layout.PageNumberSettings.Location = PageNumberLocation.BOTTOM;
		}
	},

	components: {
		AppPageSettingsBackgroundImage,
		AppPageSettingsDefault,
		AppPageSettingsFont,
		AppDefaultLanguage,
		AppPropSelectAutocomplete,
		AppMarginEdit,
		AppStyleEditor,
		AppCustomCss
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
